var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-card"},[_c('div',{staticClass:"m-card__body"},[_c('div',{staticClass:"m-card__body-content"},[_c('a',{staticClass:"m-card__body-link",attrs:{"href":_vm.data.url,"target":_vm.getTarget(_vm.data.url)}},[_c('img',{attrs:{"src":_vm.data.logo}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }